import { Reason } from '../../types/api/stamp-write-off'

export const stampWriteOffReasons: Reason[] = ['Брак', 'Поломка', 'Ресурс исчерпан']
